import type { TypeLocalEnv } from "@/types";

export const SUPPLIER = "supplier";
export const CURRENT_SHOP = "current_shop";
export const CURRENT_USER = "current_user";
export const API_PREFIX = "/api";
export const API_PREFIX_JAVA = "/router";
export const API_PREFIX_PHP_OS = "/baoban"; // os 接口前缀
export const API_PREFIX_PHP_ERP = "/baob"; // erp 接口前缀
export const API_PREFIX_MPC = "/mpc"; // modi MPC 接口前缀
export const REGEXP_API_TRANSFER = /^\/baob|mpc\//; // 转发的api正则
export const API_PREFIX_JAVA_REDIRECT = "/redirect"; // java 透传 php
export const UPLOAD_DIR = "obs/baoban_web/"; // obs 上传的目录
export const UPLOAD_DIR_PROJECT = "baoban_web"; // obs 上传的项目
export const OBS_POSTER_SUFFIX = "?vframe/jpeg/offset/1";
export const MESSAGE_LOGIN_KEY = "messageLoginKey";
export const REGEXP_VIDEO_TYPE = /\.?(mp4|mp3|webm|ogg|wav|flac|aac|mov)/i;
export const VIDEO_EXTENSION_LIST = [
  "mp4",
  "mp3",
  "webm",
  "ogg",
  "wav",
  "flac",
  "aac",
  "mov",
];
export const REGEXP_ORIGIN = /^http(s)?:\/\/.*\.com\//;
export const REGEXP_ORIGIN_YISHOU = /^http(s)?:\/\/.*\.yishou(app)?\.com\//;
export const LOCAL_ENV = "LOCAL_ENV";
/**
 * 页面路径
 */
export const pages = {
  home: "/",
  login: "/user/login",
  auth: "/connect",
  goodsList: "/goods/list",
  goodsDetail: "/goods/detail",
  dataTradePage: "/data/trade",
  dataGoodsPage: "/data/goods",
  dataFlowPage: "/data/flow",
  liveDetailPage: "/live/liveDataDetail",
};

/**
 * 业务成功码
 */
export const SUCCESS_CODE_LIST = [0, 200, "200"];
/**
 * 业务失败码
 */
export const ERROR_CODE = {
  notLoggedIn: -1, // 未登录
  notBossAccount: -5, // 非老板账号
  mismatchShopGoods: 10001,
};

// 需要透传的接口路径
export const API_REDIRECT_LIST = ["/baoban/CommonPc/baobanPcExport"];

// 商家身份
export const Identity = {
  is_platform_supply: 2, // 已审核的
};

// 审核与非免审
export enum Exemption {
  yes = 0, // 需要审核
  no = 1, // 不需要审核，即免审
}

// 品类相关
export const Categories = {
  suit: ["314", "460", "536"], // 套装品类id
};

// 元素id
export const ElementId = {
  //带边距尺码图
  sizeTableImageMargin: "sizeTableImageMargin",
  //无边距尺码图
  sizeTableImage: "sizeTableImage",
  //带边距模特图
  modelTableImageMargin: "modelTableImageMargin",
  //无边距尺码图
  modelTableImage: "modelTableImage",
};

export const UploadAccept = {
  image: "image/*",
  video: "video/*",
  excel:
    ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

// app 公共信息
export const APP = {
  appName: "爆版商家管理后台",
};

// 联调环境
export const EnvMap = {
  os: {
    title: "切换商城环境",
    host: [
      "http://os-stable",
      "http://os-feat-",
      "https://os-stable",
      "https://os-feat-",
      "test",
      "dev",
    ],
    suffix: [".yishou.com", ".yishouapp.com"],
  },
  erp: {
    title: "切换 erp 环境",
    host: [
      "http://erp-stable",
      "http://erp-feat-",
      "https://erp-stable",
      "https://erp-feat-",
      "erp",
    ],
    suffix: [".yishou.com", ".yishouapp.com"],
  },
};

/**
 * 默认环境
 */
export const DEFAULT_LOCAL_ENV: TypeLocalEnv = {
  os: "",
  osHost: EnvMap.os.host[0],
  osSuffix: EnvMap.os.suffix[0],
  erp: "",
  erpHost: EnvMap.erp.host[0],
  erpSuffix: EnvMap.erp.suffix[0],
};

/**
 * 头部高度
 */
export const OFFSET_HEADER = 56;
